import { Container, Row, Col } from 'react-bootstrap';
import styled from "styled-components"

import FooterLogo from '../../assets/images/Logomark - White.png';
import BBB from '../../assets/images/ab-seal-horizontal-black-large.jpg';
import LinkedIn from '../../assets/images/Social - In-White-26.png';
import Facebook from '../../assets/images/Social - Facebook_Logo_Secondary.png';
import Insta from '../../assets/images/Social - Instagram_Glyph_White.png';

import '../GlobalStyle.css';

const FooterList = styled.div`
    text-transform: uppercase;
    color: #ffffff;

    a {
        display: block;
        color: #ffffff;
        text-decoration: none;
        font-weight: normal;
        text-transform: none;
        padding: .25rem 0;

        &:hover {
            text-decoration: underline;
        }
    }

    svg {
        fill: #fff;
        vertical-align: top;
        margin-right: .5rem;
    }

    div {
        text-transform: none;
        padding: 1rem 0;
    }
`

const SocialLinks = styled.div`
    font-weight: bold;
    text-transform: uppercase;
    color: #ffffff;

    a {
        color: #ffffff;
    }
`

const getCurrentYear = () => {
    return new Date().getFullYear();
};

const Footer = () => {
    return (
        <>
            <Container fluid className='bg-midnight py-5'>
                <Row>
                    <Col xl={1} sm={12} className='pt-3 pb-4'>
                        <img src={FooterLogo} alt="Best Payment Solutions" width='60px' />
                    </Col>
                    <Col xl={2} md={4} sm={6} className='py-4'>
                        <FooterList>
                            <strong>Programs</strong>
                            <a href='/channel-sales'>Channel Sales</a>
                            <a href='/sales-contests'>Sales Contests</a>
                            <a href='/referrals'>Referrals</a>
                            <a href='/rebates'>Rebates</a>
                            <a href='/payments'>Payments</a>
                            <a href='/ebike-incentives'>Ebike Incentives</a>
                            <a href='/custom-incentive-programs'>Custom Incentive Programs</a>
                        </FooterList>
                    </Col>
                    <Col xl={2} md={4} sm={6} className='py-4'>
                        <FooterList>
                            <strong>Products & Services</strong>
                            <a href='/technology'>Technology</a>
                            <a href='/support-services'>Support Services</a>
                            <a href='/visa-prepaid-cards'>Visa Prepaid Cards</a>
                            <a href='/egift-cards'>EGiftcards</a>
                            {/* <a href='/card-ordering'>Card Ordering</a> */}
                        </FooterList>
                    </Col>
                    <Col xl={2} md={4} sm={6} className='py-4'>
                        <FooterList>
                            <strong>Resources</strong>
                            <a href='/about'>About</a>
                            <a href='/knowledge-center'>Knowledge Center</a>
                            <a href='faqs'>FAQ</a>
                            <a href='https://app.termly.io/document/privacy-policy/a800b269-f5d8-4518-b89e-73d8500a29d2' target='_blank'>Privacy Policy</a>
                            <a href='https://app.termly.io/document/terms-of-use-for-website/8a62abe5-558e-4bd5-9f18-f400014b43c1' target='_blank'>Terms of Service</a>
                        </FooterList>
                    </Col>
                    <Col xl={3} md={8} sm={6} className='py-4'>
                        <FooterList>
                            <strong> Contact Us</strong>
                            <a href='/schedule-demo'>Schedule a Demo</a>
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="20"><path d="M798-120q-125 0-247-54.5T329-329Q229-429 174.5-551T120-798q0-18 12-30t30-12h162q14 0 25 9.5t13 22.5l26 140q2 16-1 27t-11 19l-97 98q20 37 47.5 71.5T387-386q31 31 65 57.5t72 48.5l94-94q9-9 23.5-13.5T670-390l138 28q14 4 23 14.5t9 23.5v162q0 18-12 30t-30 12ZM241-600l66-66-17-94h-89q5 41 14 81t26 79Zm358 358q39 17 79.5 27t81.5 13v-88l-94-19-67 67ZM241-600Zm358 358Z" /></svg>
                            800-371-6801
                            <a href='mailto:info@bestpayment.solutions'>
                                <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="24"><path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z" /></svg>
                                info@bestpayment.solutions</a>
                            <div>
                                PO Box 601058
                                <br />
                                San Diego CA 92120
                            </div>
                        </FooterList>
                    </Col>
                    <Col xl={2} md={4} sm={6} className='py-4'>
                        <SocialLinks>
                            <strong>Follow Us</strong>
                            <div className='pt-2 pb-4'>
                                <a href='https://www.linkedin.com/company/best-payment-solutions-inc./mycompany/' target='_blank'><img src={LinkedIn} alt="linkedin" width={24} /></a>
                                <a href='https://www.facebook.com/bestpaymentsolutions/' target='_blank'><img src={Facebook} className='mx-4' alt="facebook" width={24} /></a>
                                <a href='https://www.instagram.com/accounts/login/?next=https%3A%2F%2Fwww.instagram.com%2Fbestpayment.solutions%2F' target='_blank'><img src={Insta} alt="instagram" width={24} /></a>
                            </div>
                            <a href='https://www.bbb.org/us/ca/san-diego/profile/incentive-programs/best-payment-solutions-inc-1126-1000118577' target='_blank'><img src={BBB} alt="" width={180} /></a>
                        </SocialLinks>
                    </Col >
                </Row >
                <Row className='justify-content-center px-5'>
                    <Col className='border-top border-secondary'>
                        <p className='text-center text-white pt-4'>© {getCurrentYear()} Best Payment Solutions, Inc.</p>
                    </Col>
                </Row>
            </Container >
        </>
    );
}

export default Footer;